import { Query, VaroAdvanceProductsInput } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { isVaroAdvanceProductsError } from 'features/advance/helpers/Advance.helpers';
import fetchVaroAdvanceProducts from 'services/graphql/queries/advance/fetchVaroAdvanceProducts';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { RequestPolicy, useQuery } from 'urql';

const useVaroAdvanceProducts = (
  requestPolicyProp?: RequestPolicy,
  pause: boolean = false,
  useMla: boolean = false,
) => {
  const router = useRouter();
  const requestPolicy = requestPolicyProp || 'network-only';
  const [{ data, fetching, error }, refetch] = useQuery<
    Query,
    { input: VaroAdvanceProductsInput }
  >({
    query: fetchVaroAdvanceProducts,
    requestPolicy: requestPolicy,
    pause: pause,
    variables: { input: { useMla } },
  });

  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: () => router.back(),
    },
  };

  const errorModel =
    !!error?.message || isVaroAdvanceProductsError(data?.varoAdvanceProducts)
      ? {
          screenType: ErrorScreenType.Error,
          messageHeadline: defaultTitle,
          messageBody: defaultMessage,
          ...buttons,
        }
      : null;

  return {
    fetching,
    error: errorModel,
    data: data?.varoAdvanceProducts,
    refetch,
  };
};

export default useVaroAdvanceProducts;
